import { calculateTimeDifference, isValidDate } from '@frontend/common';
import { format } from 'date-fns';
import React, { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export interface RelativeDateBadgeProps {
    date?: Date | string | null;
    displayTime?: boolean;
    inline?: boolean;
    emptyValue?: React.ReactNode;
}

const formatExactTimestamp = (dateString: string, displayTime: boolean, inline: boolean): string => {
    const formattedDate = format(new Date(dateString), 'dd/MM/yyyy');

    if (!displayTime) {
        return formattedDate;
    }

    const formattedTime = format(new Date(dateString), 'HH:mm');
    return inline ? `${formattedDate} • ${formattedTime}` : `${formattedDate}\n${formattedTime}`;
};

export const RelativeDateBadge = (props: RelativeDateBadgeProps) => {
    const tooltipId = useId().replace(/:/g, '');

    if (props.date == null || props.date === '') {
        return <>{props.emptyValue ?? null}</>;
    }

    const dateString = typeof props.date === 'string' ? props.date : props.date.toISOString();

    if (!isValidDate(dateString)) {
        return <span>{dateString}</span>;
    }

    const displayTime = props.displayTime ?? true;
    const inline = props.inline ?? true;

    return (
        <OverlayTrigger
            placement='top'
            delay={{ show: 300, hide: 150 }}
            popperConfig={{ strategy: 'fixed' }}
            overlay={
                <Tooltip
                    id={tooltipId}
                    className='border-border-default bg-background-surface z-1000 rounded-lg border shadow-sm'>
                    <span className='block px-2 py-1'>{formatExactTimestamp(dateString, displayTime, inline)}</span>
                </Tooltip>
            }>
            <span
                tabIndex={0}
                className='cursor-default'>
                {calculateTimeDifference(dateString)}
            </span>
        </OverlayTrigger>
    );
};
